<button
    class="w-full h-full rounded-[14px] border-2 border-dashed border-primary-500 bg-primary-100 flex flex-col justify-center items-center select-none p-6 gap-2"
    (click)="fileManagementHelper.click(fileInput)" (dragover)="fileManagementHelper.onDragOver($event)"
    (drop)="fileManagementHelper.onDrop($event, acceptType!)">
    <input #fileInput type="file" accept=".xlsx" class="hidden"
        (change)="fileManagementHelper.onFileSelected($event, acceptType!)" />

    <img src="assets/icons/upload-circle.svg" width="50px" height="50px" alt="Upload Excel Icon" />
    <p class="text-center text-sm text-neutral-1600"><span class="underline">{{ 'shared.click_to_upload.click' |
            transloco }}</span>{{ 'shared.click_to_upload.to_upload' | transloco }}<span class="underline">{{
            'shared.click_to_upload.drag_and_drop' | transloco }}</span></p>
    <p class="text-xs text-neutral-400 text-center">{{ 'admin.excel_only' | transloco }}</p>
</button>